import Swal from 'sweetalert2-neutral';

export const Alert = (title, description, options = []) => {
  const buttons = Array.isArray(options) ? options : [];

  // Identify confirm and cancel buttons following RN Alert button API
  const confirmButton =
    buttons.find(option => option.style === 'destructive') ||
    buttons.find(option => option.style === 'default') ||
    buttons[0];

  const cancelButton = buttons.find(option => option.style === 'cancel');

  const hasActions = buttons.length > 0;

  Swal.fire({
    title,
    html: `<div class="swal-content-custom">${description}</div>`,
    confirmButtonText: confirmButton?.text || 'OK',
    // Disable backdrop and create our own
    backdrop: false,
    allowOutsideClick: hasActions ? false : true,
    showCancelButton: !!cancelButton,
    cancelButtonText: cancelButton?.text || 'Cancel',
    // Use the same font family as the rest of the app
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-confirm-custom',
      cancelButton: 'swal-cancel-custom',
    },
    // Create our own semi-transparent overlay
    didOpen: () => {
      // Create a custom backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'custom-swal-backdrop';
      backdrop.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 9998;
        pointer-events: none;
      `;
      document.body.appendChild(backdrop);

      // Move the SweetAlert2 container above our backdrop
      const swalContainer = document.querySelector('.swal2-container');
      if (swalContainer) {
        swalContainer.style.zIndex = '9999';
      }
    },
    // Clean up our custom backdrop when closed
    didClose: () => {
      const backdrop = document.querySelector('.custom-swal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    },
  }).then(result => {
    if (result.isConfirmed && confirmButton?.onPress) {
      confirmButton.onPress();
    } else if (result.isDismissed && cancelButton?.onPress) {
      cancelButton.onPress();
    }
  });
};
